import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Rsvp from './Rsvp';
import RsvpV2 from './RsvpV2';

// RsvpBase controls which component is rendered while both v1 and v2 are supported for
// the first couple months after the Multiple Events launch.

function RsvpBase({ enableEventsV2 }) {
  // console.log(enableEventsV2);
  if (enableEventsV2) {
    return <RsvpV2 />;
  }
  return <Rsvp />;
}

RsvpBase.propTypes = {
  enableEventsV2: PropTypes.bool
};

const mapStateToProps = state => ({
  enableEventsV2: state.publicWebsite.wedding.enable_events_v2
});

export default connect(
  mapStateToProps
)(RsvpBase);



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/RsvpBase.jsx
 **/